const ActionCommentField = ({
    label = 'Comentario',
    placeholder,
    value,
    onChange,
    required = false,
}) => (
    <div className="mb-3">
        <span
            className="d-block fw-bold text-uppercase mb-2"
            style={{ color: '#555', fontSize: '0.7rem' }}
        >
            {label}
            {!required && (
                <span
                    style={{
                        fontWeight: 400,
                        textTransform: 'none',
                        color: '#999',
                        marginLeft: 4,
                    }}
                >
                    (opcional)
                </span>
            )}
        </span>
        <textarea
            className="form-control"
            rows={3}
            placeholder={placeholder}
            value={value}
            onChange={onChange}
            style={{ fontSize: '0.85rem', borderRadius: 8 }}
        />
    </div>
);

export default ActionCommentField;
